import React from 'react';
import { Container, Typography, Box, List, ListItem, ListItemText } from '@mui/material';

const ReturnsExchangePolicy = () => {
  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Typography variant="h3" gutterBottom fontWeight={700}>Returns & Exchange Policy</Typography>
      <Typography variant="subtitle1" color="text.secondary" paragraph>
        Please review this policy carefully before placing an order.
      </Typography>

      <Box mt={3}>
        <Typography variant="h5" gutterBottom>Returns</Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          We do NOT accept returns for any products, as each item is custom-made based on your inputs (images/text). Please verify your selections before confirming your order.
        </Typography>
      </Box>

      <Box mt={3}>
        <Typography variant="h5" gutterBottom>Exchange Eligibility</Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          Exchanges are only allowed in the following cases:
        </Typography>
        <List dense>
          <ListItem><ListItemText primary="Damage during shipping" /></ListItem>
          <ListItem><ListItemText primary="Manufacturing defects (print errors, wrong product, severe quality defects)" /></ListItem>
        </List>
        <Typography variant="body1" color="text.secondary" paragraph>
          An unedited, continuous unboxing video is REQUIRED to claim an exchange. Without this, we cannot process an exchange request.
        </Typography>
      </Box>

      <Box mt={3}>
        <Typography variant="h5" gutterBottom>What is NOT Covered</Typography>
        <List dense>
          <ListItem><ListItemText primary="Minor color differences due to screen vs print" /></ListItem>
          <ListItem><ListItemText primary="User-provided low-resolution or blurred images" /></ListItem>
          <ListItem><ListItemText primary="Wear and tear after delivery" /></ListItem>
          <ListItem><ListItemText primary="Incorrect customization details provided by user" /></ListItem>
        </List>
      </Box>

      <Box mt={3}>
        <Typography variant="h5" gutterBottom>Exchange Process</Typography>
        <List dense>
          <ListItem><ListItemText primary="Email info@therandomstore.com within 48 hours of delivery" /></ListItem>
          <ListItem><ListItemText primary="Include order ID, issue description, and unboxing video link" /></ListItem>
          <ListItem><ListItemText primary="We assess and confirm eligibility" /></ListItem>
          <ListItem><ListItemText primary="Replacement will be produced and shipped" /></ListItem>
        </List>
      </Box>

      <Box mt={3}>
        <Typography variant="h5" gutterBottom>Contact</Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          For exchange-related queries: info@therandomstore.com
        </Typography>
      </Box>
    </Container>
  );
};

export default ReturnsExchangePolicy;
